export default function deepClone(obj, isZero = false) {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }
  var temp = obj.constructor()
  for (var key in obj) {
    temp[key] = isZero ? 0 : deepClone(obj[key])
  }
  return temp
}
